import { useAuth0 } from '@auth0/auth0-react';

const ROLES_NAMESPACE = process.env.REACT_APP_AUTH0_ROLES_NAMESPACE || 'https://byteboard.app/roles';

/**
 * Returns the current user's role information extracted from the Auth0 ID token.
 *
 * Usage:
 *   const { isAdmin, isCreator, isUser, roles } = useRole();
 *
 * Requires the Auth0 Action that stamps roles onto the token under ROLES_NAMESPACE.
 */
const useRole = () => {
  const { user, isAuthenticated } = useAuth0();

  if (!isAuthenticated || !user) {
    return { roles: [], isAdmin: false, isCreator: false, isUser: false };
  }

  const roles = user[ROLES_NAMESPACE] || [];

  return {
    roles,
    isAdmin:   roles.includes('admin'),
    isCreator: roles.includes('creator'),
    isUser:    roles.includes('user') && !roles.includes('admin') && !roles.includes('creator'),
  };
};

export default useRole;
